module.exports = __webpack_public_path__ + "img/jackpot-title.87459f55.png";